import { styled } from "styled-components";

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  z-index: 1000;
`;

export const TooltipContainer = styled.div`
  background: white;
  padding: 16px;
  margin-right: 15%;
  border-radius: 8px;
  position: relative;
  max-width: 300px;
  align-items: flex-start;
`;
export const TooltipTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 20px;
`;

export const TooltipSubTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutral[600]};
`;

export const Arrow = styled.div`
  position: absolute;
  bottom: -15px;
  right: 40px;
  transform: translateX(-50%);
  width: 25px;
  height: 15px;
  background-color: white;
  clip-path: polygon(50% 100%, 0% 0%, 100% 0%);
`;

export const CharacterImageWrapper = styled.div`
  width: 20%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;
